module.exports = __webpack_public_path__ + "static/shoe-layers-3-96deb727fde193acaba1eb6925533a03.png";